// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__25q5Q"};